$( document ).ready(function() {
    let stripe = Stripe(window.App.stripeKey)
    let elements = stripe.elements()
    let style = {
        base: {
            color: '#000',

            fontSmoothing: 'antialiased',
            fontSize: '0.9rem',
            '::placeholder': {
                color: '#c9c9c9'
            }
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
        }
    }
    let card = elements.create('card', {
        hidePostalCode: true,
        style: style
    })
    if (document.getElementById('card-element')) {
        card.mount('#card-element');
    }
    let paymentMethod = null
    let hidePostalCode = true
    $('#purchase-button').on('click', function (e) {
        $('#purchase-button').prop('disabled', true)
        if (paymentMethod) {
            return true
        }

        stripe.confirmCardSetup(
            window.App.client_secret,
            {
                payment_method: {
                    card: card,
                    billing_details: {name: $('#card-holder-name').val()}
                }
            }
        ).then(function (result) {
            if (result.error) {
                $('.stripe_error').css('display', 'block');
                $('.stripe_error').html('<strong>'+result.error.type+':</strong> '+result.error.message).delay(7000).fadeOut(400);
                $('#purchase-button').prop('disabled', false)
            } else {
                $('#purchase-button').html('<div id="loader"><div class="spinner-border spinner-border-sm text-white m-auto" role="status"><span class="sr-only">Loading...</span></div></div>');
                paymentMethod = result.setupIntent.payment_method
                $('#payment-method').val(paymentMethod)
                $('#checkout-form').submit()
            }
        })
        return false
    })

    $('#coupon-check').on('click', function (e) {
        e.preventDefault();
        $('#coupon-text').text('');
        $.get({
            url: "/member/coupon?coupon_code=" + $('#coupon').val(),
            contentType: 'json',
        }).done(function(result) {
            if (result.error_text) {
                $('#coupon-text').text(result.error_text);
            }
            else {
                $('#coupon-text').text(result.name);
                let paying_amount = ($('#paying_amount').val());
                let discount_amount = 0;
                let pay_amount = '';

                if (result.percent_off !== null){
                    discount_amount = result.percent_off / 100;
                    pay_amount = paying_amount - (paying_amount * discount_amount);
                }
                else if (result.amount_off !== null){
                    discount_amount = result.amount_off / 100;
                    pay_amount = paying_amount - discount_amount;
                }

                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'usd',
                    minimumFractionDigits: 2
                })
                $('#cart-total').html(formatter.format(pay_amount  / 100));
            }
        })
    })
});
